import { render, staticRenderFns } from "./capital-market-publications.vue?vue&type=template&id=225d4fa7&scoped=true&lang=pug"
import script from "./capital-market-publications.vue?vue&type=script&setup=true&lang=js"
export * from "./capital-market-publications.vue?vue&type=script&setup=true&lang=js"
import style0 from "@ui-common/vue-spinner/dist/vue-spinner.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./capital-market-publications.vue?vue&type=style&index=1&id=225d4fa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225d4fa7",
  null
  
)

export default component.exports